import { makeRequest } from "./api";

export const FetchMinNights = async () => {
  return makeRequest("/api/admin/minNights/fetch");
};

export const UpdateMiniNights = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/minNights/update", {
    method: "PUT",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};
